import request from '@/services/request'

export default {
  initData: {
    url: '/productReview/page',
    method: 'post',
    desc: 'review初始数据'
  },
  crawPage: {
    url: '/feedback/report/crawPage',
    method: 'post',
    desc: 'review初始数据'
  },
  /**
   * 获取 添加监控商品可选列表
   * @param {*} data
   * @param {*} options
   * @returns
   */
  fetchGoodsMonitorList: (data, options = {}) => {
    return request(
      {
        url: '/review/monitor/getGoodsMonitorPage',
        method: 'post',
        desc: '获取 添加监控商品可选列表'
      },
      data,
      options
    )
  },
  /**
   * 获取已经监控中的商品列表
   * @param {} data { countryCodeList, shopIdList, asin }
   * @param {*} options
   * @returns
   */
  fetchGoodsMonitoredList: (data, options = {}) => {
    return request(
      {
        url: '/review/monitor/getAllGoodsMonitor',
        method: 'post',
        desc: '获取 添加监控商品可选列表'
      },
      data,
      options
    )
  },
  /**
   * 添加监控商品
   * @param {*} data { asin, countryCode }
   * @param {*} options
   * @returns
   */
  fetchAddMonitorGoods: (data, options = {}) => {
    return request(
      {
        url: '/review/monitor/add',
        method: 'post',
        desc: '添加监控商品'
      },
      data,
      options
    )
  },
  /**
   * 删除监控商品
   * @param {*} data { asin, countryCode }
   * @param {*} options
   * @returns
   */
  fetchDelMonitorGoods: (data, options = {}) => {
    return request(
      {
        url: '/review/monitor/delete',
        method: 'post',
        desc: '删除监控商品'
      },
      data,
      options
    )
  }
}
